import { useParams } from "react-router-dom";

import { IMAGE_BASE_URL, POSTER_SIZE } from "../config";

//components
import Grid from "./Grid/Grid";
import Spinner from "./Spinner/Spinner";
import BreadCrumb from "./BreadCrumb/BreadCrumb";
import MovieInfo from "./MovieInfo/MovieInfo";
import MovieInfoBar from "./MovieInfoBar/MovieInfoBar";
import Actor from "./Actor/Actor";

//Hook
import { useMovieFetch } from "../hooks/useMovieFetch";

//Image
import noImg from "../images/no_image.jpg";

const Movie = () => {
  const { movieId } = useParams(); //this will give us the id we created in the route
  const { state: movie, loading, error } = useMovieFetch(movieId);
  

  if (loading) return <Spinner />;
  if (error) return <div>Oops!! Something went wrong...</div>;

  return (
    <>
      <BreadCrumb movieTitle={movie.original_title} />
      <MovieInfo movie={movie} />
      <MovieInfoBar
        time={movie.runtime}
        budget={movie.budget}
        revenue={movie.revenue}
      />
      <Grid header="Actors">
        {movie.theActors.map((actor) => (
          <Actor
            key={actor.credit_id}
            name={actor.name}
            character={actor.character}
            imageURL={
              actor.profile_path
                ? `${IMAGE_BASE_URL}${POSTER_SIZE}${actor.profile_path}`
                : noImg
            }
          />
        ))}
      </Grid>
      
    </>
  );
};

export default Movie;
